import { AlwaysValidValidator } from "../validator/always-valid.validator";
import { FormSpecification } from "../../interface/type/form-specification.type";
import { IdentityConverter } from "../converter/identity.converter";
import { AreaWithoutZoneConverter } from "../converter/area-without-zone.converter";
import { CampaignIdValidator } from "../validator/campaign-id.validator";

	/**
	 * @description
	 *  Formulario de vector de estructura comercial.
	 */

export const StructureVectorForm: FormSpecification = {

	"campaignId": {
		crossValidator: false,
		default: undefined,
		validatorFactory: CampaignIdValidator,
		converter: IdentityConverter,
		errors: [
			{ type: "required", message: "Debe especificar una campaña para seleccionar una estructura comercial." }
		]
	},
	"countryLevelId": {
		crossValidator: false,
		default: undefined,
		validatorFactory: AlwaysValidValidator,
		converter: IdentityConverter,
		errors: []
	},
	"commerceLevelId": {
		crossValidator: false,
		default: undefined,
		validatorFactory: AlwaysValidValidator,
		converter: IdentityConverter,
		errors: []
	},
	"divisionLevelId": {
		crossValidator: false,
		default: undefined,
		validatorFactory: AlwaysValidValidator,
		converter: IdentityConverter,
		errors: []
	},
	"zoneLevelId": {
		crossValidator: false,
		default: undefined,
		validatorFactory: AlwaysValidValidator,
		converter: IdentityConverter,
		errors: []
	},
	"areaLevelId": {
		crossValidator: false,
		default: undefined,
		validatorFactory: AlwaysValidValidator,
		converter: AreaWithoutZoneConverter,
		errors: []
	}
};
